import { MapStyle, RoomShapeFamily } from '../../types/map.types';

export interface StyleParams {
  shapeWeights: Partial<Record<RoomShapeFamily, number>>;
  minRoomSize: number;
  maxRoomSize: number;
  roomPadding: number;
  corridorWidth: number;
  corridorWindiness: number;
  organicErosion: number;
}

export const STYLE_PRESETS: Record<MapStyle, StyleParams> = {
  dungeon: {
    shapeWeights: { rect: 5, lshape: 3, cross: 2, octagon: 1, composite: 2 },
    minRoomSize: 5,
    maxRoomSize: 10,
    roomPadding: 1,
    corridorWidth: 2,
    corridorWindiness: 0,
    organicErosion: 0,
  },
  cavern: {
    shapeWeights: { organic: 6, ellipse: 3, composite: 3 },
    minRoomSize: 6,
    maxRoomSize: 12,
    roomPadding: 2,
    corridorWidth: 2,
    corridorWindiness: 0.7,
    organicErosion: 0.35,
  },
  labyrinth: {
    shapeWeights: { rect: 4, lshape: 4, cross: 3, diamond: 2 },
    minRoomSize: 4,
    maxRoomSize: 7,
    roomPadding: 1,
    corridorWidth: 1,
    corridorWindiness: 0.3,
    organicErosion: 0,
  },
  open: {
    shapeWeights: { ellipse: 5, octagon: 3, composite: 3, organic: 2 },
    minRoomSize: 8,
    maxRoomSize: 16,
    roomPadding: 1,
    corridorWidth: 3,
    corridorWindiness: 0,
    organicErosion: 0.15,
  },
};
